import dayjs from 'dayjs'
import {
	ORDER_TRADE_SELL_BUY,
	ORDER_SET_EXECUTION_ENTRY_RATE,
	ORDER_SET_PIP,
	ORDER_SET_STOP_LOSS,
	ORDER_SET_TAKE_PROFIT,
	ORDER_SET_USED_MARGIN,
	ORDER_SET_LOT,
	ORDER_SET_SL_LINE,
	ORDER_SET_TP_LINE
} from './actions'

const initialState = {
	delayPricer: 0,
	executionEntryRate: 0,
	formType: 'forexHigh',
	isSunday: dayjs().get('d') === 0,
	leverage: 1,
	loginUserCurrency: 'USD',
	lotCountData: {},
	openTradeSellBuy: '',
	pipDecimalPlaces: dayjs().get('d') === 0 ? 2 : 4,
	pipValue: 1,
	// todo? spread,
	spread: 0,
	stopLoss: '',
	takeProfit: '',
	usedMargin: 0,
	stopLossLine: '',
	takeProfitLine: ''
}

export default (state = initialState, action) => {
	switch (action.type) {
	case ORDER_TRADE_SELL_BUY: {
		return {
			...state,
			openTradeSellBuy: action.payload
		}
	}
	case ORDER_SET_STOP_LOSS: {
		return {
			...state,
			stopLoss: action.payload
		}
	}
	case ORDER_SET_TAKE_PROFIT: {
		return {
			...state,
			takeProfit: action.payload
		}
	}
	case ORDER_SET_SL_LINE: {
		return {
			...state,
			stopLossLine: action.payload
		}
	}
	case ORDER_SET_TP_LINE: {
		return {
			...state,
			takeProfitLine: action.payload
		}
	}
	case ORDER_SET_PIP: {
		return {
			...state,
			pipValue: action.payload
		}
	}
	case ORDER_SET_LOT: {
		return {
			...state,
			lotCountData: {...state.lotCountData, ...action.payload}
		}
	}
	case ORDER_SET_EXECUTION_ENTRY_RATE: {
		return {
			...state,
			executionEntryRate: action.payload
		}
	}
	case ORDER_SET_USED_MARGIN: {
		return {
			...state,
			usedMargin: action.payload
		}
	}

	default: {
		return state
	}
	}
}
